const getReturningUserData = require("./getReturningUserData");
const fillInReturningUserEmail = require("./fillInReturningUserEmail");
const fillInReturningUserFirstName = require("./fillInReturningUserFirstName");

/**
 * @return {void}
 */
module.exports = function populateReturningUserPlaceholders() {
    const returningUser = getReturningUserData();
    if (returningUser) {
        fillInReturningUserEmail(returningUser);
        fillInReturningUserFirstName(returningUser);
    }
}